import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { mergeStyleSets, SelectableOptionMenuItemType, Dropdown, Stack, SearchBox } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { useState, useMemo } from 'react';
import { locales } from '../../../../../../data/locales.esm.js';

/* istanbul ignore file */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var classNames = mergeStyleSets({
    link: {
        textDecoration: 'underline'
    },
    dropdownCallout: {
        padding: '8px',
        width: 'auto'
    },
    dropdownList: {
        maxHeight: 248,
        overflowY: 'auto'
    }
});
var dropdownStyles = {
    dropdownItemsWrapper: {
        overflowY: 'hidden'
    }
};
var searchTermIsMatching = function(searchTerm, value) {
    return value.toLowerCase().includes(searchTerm.toLowerCase());
};
var LocaleDropdown = function(param) {
    var locale = param.locale, disabled = param.disabled, onLocaleChange = param.onLocaleChange;
    var _useState = _sliced_to_array(useState(''), 2), localeSearchTerm = _useState[0], setLocaleSearchTerm = _useState[1];
    var localeOptions = useMemo(function() {
        return locales.map(function(l) {
            var name = l.name;
            return {
                key: name,
                text: name,
                itemType: SelectableOptionMenuItemType.Normal,
                data: l,
                hidden: !searchTermIsMatching(localeSearchTerm, name) && locale.name === name
            };
        }).filter(function(item) {
            return localeSearchTerm && !item.hidden ? searchTermIsMatching(localeSearchTerm, item.text) : true;
        });
    }, [
        locale,
        localeSearchTerm
    ]);
    var t = useTranslation('header').t;
    return /*#__PURE__*/ jsx(Dropdown, {
        placeholder: t('Select') || '',
        label: t('Language') || undefined,
        options: localeOptions,
        selectedKey: locale.name,
        styles: dropdownStyles,
        disabled: disabled,
        onChange: function(_, item) {
            return onLocaleChange(item === null || item === void 0 ? void 0 : item.data);
        },
        onDismiss: function() {
            return setLocaleSearchTerm('');
        },
        onRenderList: function(props, defaultRender) {
            return /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx(Stack, {
                        className: classNames.dropdownCallout,
                        children: /*#__PURE__*/ jsx(SearchBox, {
                            placeholder: t('Search') || '',
                            onChange: function(_, value) {
                                return setLocaleSearchTerm(value || '');
                            },
                            value: localeSearchTerm
                        })
                    }),
                    /*#__PURE__*/ jsx(Stack, {
                        className: classNames.dropdownList,
                        children: defaultRender === null || defaultRender === void 0 ? void 0 : defaultRender(props)
                    })
                ]
            });
        }
    });
};

export { LocaleDropdown as default };
